import analyticsAction from "../analytics/analytics-action"
import analyticsQualified from "../analytics/analytics-qualified"

export type QualifiedData = {
  bot: {
    id: number
    name: string
  }
  field_values: Record<string, string | number>
  bot_conversations_id: string
  message: {
    text: string
  }
  rep_conversation_id: string
  sender: {
    rep_name: string
    type: string
  }
  name: string
}

export default function qualified() {
  // We have inline JS that runs before this code so we can guarantee that window.qualified exists

  // @ts-ignore
  window.qualified("handleMessengerEvents", function (name: string) {
    const formattedName = name.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase()
    analyticsAction(`Qualified ${formattedName}`)
  })

  // @ts-ignore
  window.qualified(
    "handleEvents",
    function (name: string, data: QualifiedData) {
      analyticsQualified(name, data)
    }
  )
}
